module.exports = __webpack_public_path__ + "static/media/Home.9c9c9aff.svg";